
// @ts-nocheck


export const localeCodes =  [
  "fa",
  "en"
]

export const localeLoaders = {
  fa: [
    {
      key: "locale_fa_46json_52da28b2",
      load: () => import("#nuxt-i18n/52da28b2" /* webpackChunkName: "locale_fa_46json_52da28b2" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => import("#nuxt-i18n/0b63539c" /* webpackChunkName: "locale_en_46json_0b63539c" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/ee4e6a16" /* webpackChunkName: "config_i18n_46config_46ts_ee4e6a16" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "fa",
      iso: "fa-IR",
      name: "فارسی",
      dir: "rtl",
      files: [
        {
          path: "/app/i18n/locales/fa.json",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      iso: "en-US",
      name: "English",
      dir: "ltr",
      files: [
        {
          path: "/app/i18n/locales/en.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "fa",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "fa",
    iso: "fa-IR",
    name: "فارسی",
    dir: "rtl",
    files: [
      {
        path: "/app/i18n/locales/fa.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    iso: "en-US",
    name: "English",
    dir: "ltr",
    files: [
      {
        path: "/app/i18n/locales/en.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/